import React from "react";

export default function AuthCard({ overline, title, children, testid }) {
  return (
    <main className="max-w-md mx-auto px-6 py-16" data-testid={testid}>
      <div className="border-2 border-[#0A1128] bg-white p-8">
        <p className="font-overline text-xs text-[#E11D48] mb-2">{overline}</p>
        <h1 className="font-heading text-4xl tracking-tight mb-6">{title}</h1>
        {children}
      </div>
    </main>
  );
}
